import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { deviceLanguage } from "../../helpers/getLocale";
import Loading from "../../components/loading";
import StackHeader from "../../components/stackHeader";
import Icon from "../../components/icons";
import { allPodcasts } from "../../actions/podcasts";
import FloatButton from "../../components/floatButton";
import ActionSheet from "../../components/actionSheet";
import ActionSheetOnPressAction from "../../helpers/actionSheetOnPressAction";
import AssetsResourcesModal from "../../screens/balance/details/assetsResourcesModal";
import { createAssetResource, destroyAsset, editAsset } from "../../actions/balance";
import AlertModal from "../../components/alertModal";
import {AudioPlayer} from "../../components/AudioPlayer";
import {Spotify} from "../../components/icons/spotify";



const PodcastIndexScreen = (props) => {
  const [descriptionsOpened, setDescriptionsOpened] = useState([]);
  const [showLoading, setShowLoading] = useState(true);
  const [modalData, setModalData] = useState(undefined)
  const [modalSuccess, setModalSuccess] = useState(undefined)
  const [modalDelete, setModalDelete] = useState(undefined)
  const deviceLang = deviceLanguage();
  const lang = deviceLang.split("-")[0];
  const seeMore = lang === "en" ? "See more" : "Ver más";
  const seeLess = lang === "en" ? "See less" : "Ver menos";
  const [optionsActionSheet, setOptionsActionSheet] = useState([]);
  const containerRef = useRef(null);
  const actionSheet = useRef(null);
  const isSpotifyEpisodeId = (value) => /^[A-Za-z0-9]{22}$/.test(value || "");

  useEffect(() => {
    if (containerRef.current) {
      setTimeout(() => {
        containerRef.current.classList.add("active");
        setShowLoading(false);
      }, 1000);
    }
    props.getBreadcrumbs({
      url: props.history.location.pathname + props.history.location.search,
      assetUrl: props.history.location.pathname,
    });
    if (!props.podcasts || props.podcasts.length === 0) {
      props.allPodcasts(props.authentication_token, () => success(), () => "")
    }
    window.scrollTo(0, 0);
  }, []);

  const success = () => {
    containerRef.current.classList.add("active");
    setShowLoading(false);
  }

  const _actionSheetPressed = (item) => {
    item = Object.assign(item)
    let response = ActionSheetOnPressAction(
      item,
      props.podcast_alerts,
      props,
      () => actionAlert(item)
    );

    actionSheet.current.show();
    if (response.status){
      setModalData(response.modalData)
      //this.setState({ showModal: true, modalData: response.modalData });
    }
     
  }

  const actionAlert = (item) => {
    console.log({item})
    if (item.code === "delete_alert") {
      deleteAsset(item.url, item.method)
    } else if (item.code === "edit_alert") {

    }
  }

  const deleteAsset = (url, method) => {
    setModalDelete({
      modal_title: props.internalization.modals['alert'].delete.title, 
      modal_body: props.internalization.modals['alert'].delete.body,
      action: () => deleteAlert(url, method)
    })

  }

  const deleteAlert = (url, method) => {
    props.destroyAsset(
      props.authentication_token,
      () => successDeleteAsset(),
      () => alert("error"),
      url,
      "DELETE"
    );
  }

  const successDeleteAsset = () => {
    setModalSuccess({
      modal_title: props.internalization.modals['alert'].deleted.title, 
      modal_body: props.internalization.modals['alert'].deleted.body,
    })
  }

  const _getActionSheetMethod = (item) => {
    switch(item.code){
      case "add_alerts":
        return () => { _actionSheetPressed(item)};
      default: 
        return () => { _actionSheetPressed(item) }
    }
    
  }

  const _showActionSheetContent = () => {
    let that = this;
    let optionsActionSheetTemp = [];
    props.podcast_alerts.actions.map(item => {
      return optionsActionSheetTemp.push({
        type: "icon button",
        code: item.code,
        iconName: item.code === "add_alerts" ? "Notification" : item.code.includes("add")
          ? "Close"
          : item.code.includes("edit")
          ? "Pencil"
          : item.code.includes("show")
          ? "Eye"
          : item.code.includes("link")
          ? "LinkChain"
          : "Garbage",
        message: item.title,
        onClick: _getActionSheetMethod(item)
      });
    });
    optionsActionSheetTemp.push(
      {
          type: "noIcon button",
          message: props.internalization.buttons.cancel,
          close: true,
          danger: true,
          onClick: () =>  {setModalData({})}
        }
      )
    setOptionsActionSheet(optionsActionSheetTemp)

    setTimeout(function() {
      actionSheet.current.show();
    }, 100);
  }

  const createAlert = (data) => {
    if (data.alert && data.alert.title ===  undefined) {
      data.alert.title = "The Bulltick Brief podcast"
    }  
    props.createAssetResource(
      props.authentication_token,
      () => _successCreateAssetResource(modalData.method === "PUT", modalData.resource_key, modalData),
      (responseJSON) => console.log("error"),
      modalData.url,
      modalData.method,
      data
    );
  }

  const _successCreateAssetResource = (edit, key, modalData) => {
    let key_fix = ["owner_beneficiary"].includes(key) ? modalData.code === "edit_owner" ? "owner_life_insurance" : "beneficiary_life_insurance" : key
    setModalSuccess({
      modal_title: edit ? props.internalization.modals[key_fix].updated.title : props.internalization.modals[key_fix].created.title, 
      modal_body: edit ? props.internalization.modals[key_fix].updated.body : props.internalization.modals[key_fix].created.body,
    })
    setModalData({})
    //this.setState({ modal_title: edit ? props.internalization.modals[key_fix].updated.title : props.internalization.modals[key_fix].created.title, modal_body: edit ? props.internalization.modals[key_fix].updated.body : props.internalization.modals[key_fix].created.body, showSuccesModal: true, loading:false, resources: [] });  
    
  }
  const handleDescription = (index) => {
    if (descriptionsOpened.includes(index)) {
      const newDescriptions = descriptionsOpened.filter(
        (item) => item !== index,
      );
      setDescriptionsOpened([...newDescriptions]);
    } else {
      setDescriptionsOpened([...descriptionsOpened, index]);
    }
  };

  if (!props.podcasts || props.podcasts.length === 0) {
    return (
      <div className="podcasts__container">
        <h1>{lang === "en" ? "There are no podcasts" : "No hay podcasts"} </h1>
      </div>
    );
  }
  console.log(props)
  return (
    <div className="main-wrapper podcasts">
      <StackHeader
        title={"The Bulltick Brief"}
        icon={
          <Icon
            name="LogoPodcasts"
            colorPrimary={"#005774"}
            colorSecondary="#f3b01c"
            iconBig={true}
          />
        }
        help={false}
        helpAction={() => alert("boton de info del stackHeader")}
      />
      {showLoading && <Loading />}
      <div className="podcasts__container" ref={containerRef}>
        {props.podcasts.map((item, index) => {
          return (
            <div key={item.name} className="podcasts__item">
              {isSpotifyEpisodeId(item.spotify_id) ? (
                <iframe
                  data-testid="embed-iframe"
                  className="podcasts__iframe"
                  src={`https://open.spotify.com/embed/episode/${item.spotify_id}?utm_source=generator`}
                  width="300"
                  height="200"
                  allowfullscreen=""
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                ></iframe>
              ) : item.audio_preview_url ? (
                  <div className="podcasts__player">
                    <a target="_blank" href="https://open.spotify.com/show/64nIVwmtABZdonbX1xzjNS" className="podcasts__player-spotify-icon">
                      <Spotify width={32} height={32} />
                    </a>
                    <div className="podcasts__player-info">
                      {item.image && (
                        <img src={item.image} alt={item.name} className="podcasts__cover" />
                      )}
                      <div>
                        {item.name && (
                          <div className="marquee-wrapper">
                            <p className="podcasts__player-info-name marquee-content">{item.name}</p>
                          </div>
                        )}
                        {item.name && (
                          <a target="_blank" className="podcasts__player-info-brief" href="https://open.spotify.com/show/64nIVwmtABZdonbX1xzjNS">The Bulltick Brief</a>
                        )}
                      </div>
                    </div>
                    <AudioPlayer data={item} />
                  </div>
              ) : null}
              <div className="podcasts__texts">
                <p className="podcasts__title">{item.name}</p>
                <p className="podcasts__date">{item.date}</p>
                {item.description_disclaimer[0].length <= 525 && (
                  <p className="podcasts__description">
                    {item.description_disclaimer[0]}
                  </p>
                )}

                {item.description_disclaimer[0].length > 525 && (
                  <p className="podcasts__description">
                    {descriptionsOpened.includes(index)
                      ? item.description_disclaimer[0]
                      : `${item.description_disclaimer[0].substring(0, 525)}...`}

                    {item.description_disclaimer[0].length >= 525 && (
                      <span
                        className="podcasts__see-more"
                        onClick={() => handleDescription(index)}
                      >
                        {" "}
                        {descriptionsOpened.includes(index) ? seeLess : seeMore}
                      </span>
                    )}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {
        props && props.podcasts && 
        <div className="podcasts__disclaimer">
          <p>{props.podcasts[0].description_disclaimer[1]}</p>
        </div>
      }
      
      {props.podcast_alerts && props.podcast_alerts.form && (
            <div>
              <ActionSheet
                ref={actionSheet}
                render={optionsActionSheet}
                show={true}
              />
              <FloatButton
                children={
                  <Icon
                    name="Close"
                    color="white"
                    iconBig={true}
                    className="wrapper-icon-floatButton"
                    close={false}
                  />
                }
                action={() => _showActionSheetContent()}
              />
            </div>
          )}

      {modalData && Object.keys(modalData).length > 0 && (
            <AssetsResourcesModal
              language={props.user.language}
              identifier={1}
              colorGrey={true}
              data={modalData}
              errors={props.errors}
              closeModal={e => {
                if (
                  e.target.className === "modal-wrapper" ||
                  (e.target.closest(".modal-header") !== null &&
                    e.target.closest(".modal-header").className.includes("modal-header"))
                ) {
                  setModalData({})
                  //this.setState({ showModal: false, resources:{}, deletedAssets: [] });
                }
              }}
              uploadResource={data => createAlert(data)}
              resources={[]}
              goToResource={asset => console.log("goToResource")}
              polymorphic={
                false
              }
              showDocument={url => console.log("showDocument")}
              showContact={(url, idMain) => console.log("showContact")}
              resourceToSelectDestroy={false}
              resourceDestroyAction={url => console.log("resourceDestroyAction")}
              destroyAssetAssociated= {() => console.log("destroyAssetAssociated")}
              deleteDocument={(url) => console.log("deleteDocument")}
              buttons={props.internalization.buttons}
              showModalSessionExpire={(time_left, diffMins, checkTime) => console.log("showModalSessionExpire")}
              getLinkForm = {(url, success_fromblock, error_fromblock) => console.log("getLinkForm")}
              categorieOptions={props.podcast_alerts.form}
              successSendFiles={() => console.log("successSendFiles")}
            />
          )}

        {modalSuccess && Object.keys(modalSuccess).length > 0 && (
            <AlertModal
              isShowed={true}
              title={modalSuccess.modal_title}
              msg={modalSuccess.modal_body}
              action={() => {
                setModalSuccess({})
                window.location.reload()
              }}
              textButton={props.internalization.buttons.ok}
            />
          )}

        {modalDelete && Object.keys(modalDelete).length > 0 && (
            <AlertModal
              isShowed={true}
              title={modalDelete.modal_title}
              msg={modalDelete.modal_body}
              cancelButton={true}
              cancelTextButton={props.internalization.buttons.cancel}              
              action={() => {
                setModalDelete({})
                modalDelete.action()
              }}
              actionCancelButton={() => {
                setModalDelete({})
              }}
              textButton={props.internalization.buttons.ok}
            />
          )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authentication_token: state.session.authentication_token,
    podcasts: state.home.podcasts,
    podcast_alerts: state.home.podcast_alerts,
    internalization: state.session.internalization, 
    errors: state.session.errors,
    user: state.session.user,        
  };
};
function mapDispatchToProps(dispatch) {
  return {
    destroyAsset: (authentication_token, success, error, url, method) =>
      dispatch(destroyAsset(authentication_token, success, error, url, method)),    
    createAssetResource: (authentication_token, success,error,url,method,attributes) =>dispatch(createAssetResource(authentication_token,success,error,url,method,attributes)),
    allPodcasts: (authentication_token, success, error) => dispatch(allPodcasts(authentication_token, success, error)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PodcastIndexScreen);
